var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11573_1083)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    fill: "url(#paint0_linear_11573_1083)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11573_1083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13924 16.4998C9.13924 12.778 11.4207 10.7762 14.9859 10.7762C18.5794 10.7762 20.861 12.7782 20.861 16.4998C20.861 20.2214 18.5794 22.2236 14.9859 22.2236C11.4208 22.2236 9.13924 20.2218 9.13924 16.4998ZM14.9859 9C10.1942 9 7 11.8194 7 16.4998C7 21.1803 10.1942 24 14.9859 24C19.8058 24 23 21.1803 23 16.4998C23 11.8194 19.8057 9 14.9859 9Z",
    fill: "url(#paint1_linear_11573_1083)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_11573_1083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 11.7278 20.532 11.531 20.254 11.2795C19.976 11.0281 19.5685 10.7996 19.0548 10.6071C18.541 10.4146 17.9312 10.2619 17.26 10.1578C16.5888 10.0536 15.8694 10 15.1429 10C14.4164 10 13.697 10.0536 13.0258 10.1578C12.3546 10.2619 11.7447 10.4146 11.231 10.6071C10.7173 10.7996 10.3098 11.0281 10.0318 11.2795C9.75377 11.531 11.3906 10.3349 11.3906 10.6071L11.9114 10.862C11.9114 10.6372 10.6911 11.6252 10.9208 11.4175C11.1505 11.2098 11.4871 11.021 11.9114 10.862C12.3358 10.703 12.8396 10.5769 13.394 10.4909C13.9485 10.4048 14.5428 10.3605 15.1429 10.3605C15.743 10.3605 16.3373 10.4048 16.8917 10.4909C17.4462 10.5769 17.95 10.703 18.3743 10.862C18.7987 11.021 18.8251 10.3994 19.0548 10.6071C19.2844 10.8148 19.8332 10.8055 19.8332 11.0303L21 12Z",
    fill: "url(#paint2_linear_11573_1083)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_11573_1083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13924 32.4998C9.13924 28.778 11.4207 26.7762 14.9859 26.7762C18.5794 26.7762 20.861 28.7782 20.861 32.4998C20.861 36.2214 18.5794 38.2236 14.9859 38.2236C11.4208 38.2236 9.13924 36.2218 9.13924 32.4998ZM14.9859 25C10.1942 25 7 27.8194 7 32.4998C7 37.1803 10.1942 40 14.9859 40C19.8058 40 23 37.1803 23 32.4998C23 27.8194 19.8057 25 14.9859 25Z",
    fill: "url(#paint3_linear_11573_1083)",
    shapeRendering: "crispEdges"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 8.5,
    stroke: "#F3F4F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11573_1083",
    x: 6,
    y: 9,
    width: 18,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945199 0 0 0 0 0.945199 0 0 0 0 0.945199 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11573_1083"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11573_1083",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11573_1083",
    x: 9.7,
    y: 9.7,
    width: 11.6,
    height: 2.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15,
    result: "effect1_foregroundBlur_11573_1083"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11573_1083",
    x: 6,
    y: 25,
    width: 18,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945199 0 0 0 0 0.945199 0 0 0 0 0.945199 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11573_1083"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11573_1083",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11573_1083",
    x1: 15,
    y1: 15,
    x2: 5.10116e-7,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11573_1083",
    x1: 19.5,
    y1: 9,
    x2: 6.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EDA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EDA6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11573_1083",
    x1: 15.6362,
    y1: 9.98182,
    x2: 15.6606,
    y2: 12.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11EFAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11573_1083",
    x1: 15,
    y1: 40,
    x2: 15,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.718577,
    stopColor: "#00EDA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EDA6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11573_1083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.c9e6d4dd117c819a34902e71f2d1df03.svg";
export { ForwardRef as ReactComponent };